//function to generate zoom handler for features in dividedAsset
export default function({map, da, zoomMap}) {

	var prevZoom = 99;
	
	if(typeof zoomMap === 'undefined') {
		var zoomMap = {
			far: 9,
			med: 11,
			close: 12
		}
	}

	return function zoomChanged(e, forceChange = false){

		if(typeof e !== 'undefined' && e.dragging){
			return false;
		}



	   	var zoom = map.getView().getZoom();

	  	if(forceChange || (typeof prevZoom !== 'undefined' && prevZoom !== zoom)) {

		  		if(zoom <= zoomMap['far']) {
		  			da.setVisibleGroup('far', true); //13
		  			da.setFullCluster();
		  		}
		  		else if(zoom <= zoomMap['med']) {
		  			da.setVisibleGroup('med', true); //13
		  			da.setFullCluster();
		  		}
		  		else if(zoom <= zoomMap['close']) {
		 
		  			da.setVisibleGroup('close', true); //13
		  			da.setFullCluster();
		  		}
		  		else if(zoom <= 16) {

		  			da.setRegularCluster(); //13
		  		} else {

		  			da.setRegularClusterMin();
		  		}
			
		}

		prevZoom = zoom;
	}
};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/map/zoomcluster.js